
const Css = {
  getStyle(marginLeft){
    return {
      width: "3px",
      height: "12px",
      backgroundColor: "#278DE7",
      marginLeft: marginLeft + "px",
      position: "absolute",
      zIndex:1,
      transition: "all 0.05s linear", //渐变动画防止视觉卡顿
    }
  }
}

export default Css;